import React from "react";
import '../../assets/css/Home/Content.css';

import Notification from '../Notification';
import RenewToken from '../RenewToken';

import Guilds from '../Home/Guilds'

const HomeContent = () => {
    return (
        <>
            <div className="mainContainer">
                <Notification title="" description="Hi <b>Midoom</b> !<br />We hope you are well?!" time={5000} />
                <RenewToken />

                <div className="guilds">
                    <Guilds />
                </div>
            </div>
        </>
    );
};

export default HomeContent;
